<template>
  <div class="scc_modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-content-donation-page">
        <div class="modal-body">
          <div
              class="alert alert-danger alert-dismissible fade show"
              role="alert"
              v-if = 'seenWarningEmail'
          >
            <!--            Your {{ userInformation.email }} on file does not match (name, dob, etc.), please check your information or call <a href="/portal/contact-us" class='link-emphasized' target="_blank"><ins>support</ins></a> for help. {{ seenWarningEmail }}-->
            {{ messAppointmentsNotTemporaryDonor }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
              class="alert alert-danger alert-dismissible fade show"
              role="alert"
              v-if = 'seenInfoMessage'
          >
            {{infoMessage}}
          </div>
          <div
              id="header-window"
              class="container-item-form"
              style="justify-content: space-between;align-items: baseline;"
          >
            <p class="p-section">Schedule Appointment</p>
            <button
                type="button"
                id="close-temporary-donor-info"
                class="close"
                @click.prevent="checkAndDeleteTemporaryAppt(apptId)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form
              id="form-filling-temporary-donor-info-portal-scc"
          >
            <div class="row container-item-form">
              <div class="container-input-form container-input-form-left col-sm">
                <label class="label-form-css" for="first-name-my-profile">First Name</label>
                <input
                    type="text"
                    class="form-control input-form-css"
                    id="first-name-my-profile"
                    :class="{'invalid-item':objInvalid.firstName}"
                    v-on:blur="firstNameFocusIn"
                    aria-describedby="firstNameHelp"
                    v-model.trim="temporaryDonorInfo.firstName"
                >
                <small id="firstNameHelp" class="form-text text-muted">Required field.</small>
              </div>
              <div class="container-input-form container-input-form-right col-sm">
                <label class="label-form-css" for="last-name-my-profile">Last Name</label>
                <input
                    type="text"
                    class="form-control input-form-css"
                    :class="{'invalid-item':objInvalid.lastName}"
                    id="last-name-my-profile"
                    v-on:blur="lastNameFocusIn"
                    aria-describedby="lastNameHelp"
                    v-model.trim="temporaryDonorInfo.lastName"
                >
                <small id="lastNameHelp" class="form-text text-muted">Required field.</small>
              </div>
            </div>
            <div class="row container-item-form">

              <div class="container-input-form container-input-form-left col-sm">
                <date-piker
                    class="container-input-form-left"
                    :dateDatePiker="temporaryDonorInfo.dob"
                    nameDatePiker="Date of Birth"
                    :error-event="objInvalid.dob"
                    v-on:changeDateDatePiker="changeDob"
                />
              </div>
              <div class="container-input-form container-input-form-left col-sm">
                <label class="label-form-css" for="last-name-my-profile">Cell #</label>
                <input
                    v-if="maskCell!==''"
                    type="tel"
                    class="form-control input-form-css"
                    :class="{'invalid-item':objInvalid.cell}"
                    id="cell-my-profile"
                    v-on:blur="cellFocusIn"
                    aria-describedby="cellHelp"
                    :placeholder="placeholderCell"
                    v-mask="maskCell"
                    v-model.trim="temporaryDonorInfo.cell"
                >
                <input
                    v-else
                    type="tel"
                    class="form-control input-form-css"
                    :class="{'invalid-item':objInvalid.cell}"
                    id="cell-my-profile"
                    v-on:blur="cellFocusIn"
                    aria-describedby="cellHelp"
                    v-model.trim="temporaryDonorInfo.cell"
                >
                <small id="cellHelp" class="form-text text-muted">Required field.</small>
              </div>
            </div>
            <div class="row container-item-form">
              <div class="container-input-form container-input-form-left col-sm">
                <label class="label-form-css" for="my_profile_donor_portal_email">Email:</label>
                <input
                    type="email"
                    class="form-control input-form-css"
                    :class="{'invalid-item':objInvalid.email}"
                    id="my_profile_donor_portal_email"
                    v-on:blur="emailFocusIn"
                    aria-describedby="emailHelp"
                    v-model.trim="temporaryDonorInfo.email"
                    :disabled="checkNewDonor === 'No'"
                >

                <small id="emailHelp" class="form-text text-muted">Required field.</small>
              </div>
            </div>
            <div class="row container-item-form " style="text-align: center;">
              <button
                  class="button-section btn button-confirm"
                  type="button"
                  v-on:click="registrationDonorTemporary"
              >
                Schedule
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line no-unused-vars
import moment from "moment-timezone";
import datePiker from "../../elements/datePiker";
import xlooLib from "../../../librarys/xlooLib";
import {mask} from  'vue-the-mask';

export default {
  name: "temporaryDonorRegistration",
  // eslint-disable-next-line vue/no-unused-components
  components: { datePiker, },
  props: [ 'apptId', ],
  data(){
    return{
      checkNewDonorPage: false,
      seenWarningEmail: false,
      seenInfoMessage: false,
      infoMessage: '',
      messAppointmentsNotTemporaryDonor: '',
      temporaryDonorInfo: {
        firstName: '',
        lastName: '',
        dob: '',
        cell: '',
        email: '',
      },
      objInvalid: {
        firstName: '',
        lastName: '',
        dob: '',
        cell: '',
        email: '',
      },
      placeholderCell: '',
      maskCell: '',
    }
  },
  directives: {
    mask
  },
  computed : {
    ...mapState({
      idDonor: state => state.donorInformation.idDonor,
      urlSite: state => state.settingsAndCustomize.configurationSite.urlSite,
      lat: state => state.donateBloodAppointments.dataRequestDonationLocation.lat,
      lng: state => state.donateBloodAppointments.dataRequestDonationLocation.lng,
      profileId: state => state.donateBloodAppointments.dataDonationLocation.profileId,
      checkNewDonor: state => state.donateBloodAppointments.dataRequestDonationLocation.checkNewDonor,
      oldDonorEmail: state => state.donateBloodAppointments.dataRequestDonationLocation.emailOldDonor,
      phoneFormat: state => state.settingsAndCustomize.crmSettings.phoneFormat,
      phoneFormats: state => state.settingsAndCustomize.crmSettings.phoneFormats,
    })
  },
  mounted(){
    let sccThis = this
    this.$root.$on('datePickerDateofBirth', date => sccThis.changeDob(date))

    this.messAppointmentsNotTemporaryDonor = this.$store.getters["settingsAndCustomize/messages"]('notFoundDonorForTemporaryDonorRegistration')

    if (this.checkNewDonor === 'No'){
      this.temporaryDonorInfo.email = this.oldDonorEmail
    }

    if(this.phoneFormat !== '' && Object.keys(this.phoneFormats).length > 0){
      this.placeholderCell = xlooLib.createMaskForPhone(this.phoneFormats[this.phoneFormat], this.phoneFormat, 'x' )
      this.maskCell = xlooLib.createMaskForPhone(this.phoneFormats[this.phoneFormat], this.phoneFormat, '#' )
    }
  },
  methods:{
    async registrationDonorTemporary(){
      let ageDonor = new Date();
      if (this.temporaryDonorInfo.dob == '' || typeof this.temporaryDonorInfo.dob === 'undefined'){
        this.errorAlert('Please enter Date of Birth.')
        this.objInvalid.dob = true;

        return;
      }
      if (this.temporaryDonorInfo.firstName == '' || typeof this.temporaryDonorInfo.firstName === 'undefined') {
        this.errorAlert('First Name - Required field')
        this.objInvalid.firstName = true;
        return false
      }
      if (this.temporaryDonorInfo.lastName == '' || typeof this.temporaryDonorInfo.lastName === 'undefined') {
        this.errorAlert('Last Name - Required field')
        this.objInvalid.lastName = true;
        return false
      }
      if (this.temporaryDonorInfo.email == '' || typeof this.temporaryDonorInfo.email === 'undefined') {
        this.errorAlert('Email - Required field')
        this.objInvalid.email = true;
        return false
      }
      if (this.temporaryDonorInfo.cell == '' || typeof this.temporaryDonorInfo.cell === 'undefined') {
        this.errorAlert('Cell - Required field')
        this.objInvalid.cell = true;
        return false
      }
      ageDonor = this.temporaryDonorInfo.dob;
      if (Number(moment().diff(ageDonor, 'years')) < 16) {
        this.errorAlert('You are ' + Number(moment().diff(ageDonor, 'years')) + ' years old. You are under 16 years old');
        this.objInvalid.dob = true;
        return
      }
      if (Number(moment().diff(ageDonor, 'years')) > 100) {
        this.errorAlert('You are ' + Number(moment().diff(ageDonor, 'years')) + ' years old. You are older than 100 years old.');
        this.objInvalid.dob = true;
        return;
      }

      var dataRegistrationDonorTemporary = {
        action: 'registrationTemproraryDonor',
        firstName: this.temporaryDonorInfo.firstName,
        lastName: this.temporaryDonorInfo.lastName,
        dob: moment(this.temporaryDonorInfo.dob).format("YYYY-MM-DD"),
        email: this.temporaryDonorInfo.email,
        cell: xlooLib.phoneCleaner(this.temporaryDonorInfo.cell),
        idDonor: this.idDonor,
        apptId: this.apptId,
        lat: this.lat,
        lng: this.lng,
        urlSite: this.urlSite
      };

      this.$root.$emit("showSpinner");
      const resRegistrationDonorTemporary = await this.$store.dispatch(
          'donateBloodAppointments/SET_registrationTemporaryDonor',
          dataRegistrationDonorTemporary
      )
      this.$root.$emit("hideSpinner");

      if (resRegistrationDonorTemporary?.data?.result === 'not set_entry'){
        this.errorAlert('We have your Email on file, your Last Name or DOB does not match our records. If both are correct, it’s possible we have a duplicate record on file with your email address (for security purposes we no longer allow more than 1 email address per account). Please call your administrator')
        return
      }
      this.$emit('afterTemporaryRegistration', resRegistrationDonorTemporary);
    },
    changeDob(date){
      this.temporaryDonorInfo.dob = moment(date).format("MM/DD/YYYY");
      this.objInvalid.dob = false
      this.cleanInfoMessage()
    },
    checkAndDeleteTemporaryAppt(deletedApptId){
      this.$root.$emit("checkAndDeleteTemporaryAppt", deletedApptId);
    },
    firstNameFocusIn(){
      this.objInvalid.firstName = false
      this.cleanInfoMessage()
    },
    lastNameFocusIn(){
      this.objInvalid.lastName = false
      this.cleanInfoMessage()
    },
    dobFocusIn(){
      this.objInvalid.dob = false
      this.cleanInfoMessage()
    },
    cellFocusIn(){
      this.objInvalid.cell = false
      this.cleanInfoMessage()
    },
    emailFocusIn(){
      this.objInvalid.email = false
      this.cleanInfoMessage()
    },
    closeInfoMessage(){
      console.log('closeInfoMessage')
      this.cleanInfoMessage()
    },
    cleanInfoMessage(){
      this.infoMessage = ''
      this.seenInfoMessage = false
    },
    errorAlert(message){
      this.infoMessage = message
      this.seenInfoMessage = true
    },
  }
}
</script>

<style scoped>
#header-window{
  display: flex;
}
#header-window p{
  font-size: 16px;
}
#close-temporary-donor-info{
  background-color: inherit;
  padding: 0 15px;
  border: none;
/*  display: none; */
}
#close-temporary-donor-info:hover span{
  color: #2c3e50;
  font-weight: 600;
}
#close-temporary-donor-info span{
  font-size: 24px;
}
</style>
